import Alpine from "alpinejs";

export function userNotificationForm() {
    Alpine.store('userNotificationData', {
        is_subscribed: false,
    });

    Alpine.data('userNotificationForm', (is_subscribed = false, user_language, user_country_code) => ({
        show_form: false,
        selected_language: user_language,
        selected_country_code: user_country_code,

        init() {
            this.$store.userNotificationData.is_subscribed = is_subscribed
            this.show_form = this.$store.userNotificationData.is_subscribed
            this.selected_country_code = (is_subscribed) ? user_country_code : 'kl_GL'
            this.$watch('selected_language', value => this.selected_language = value)

        },

        show_if_not_subscribed: {
            ["x-show"]() {
                return !this.$store.userNotificationData.is_subscribed
            },
        },

        show_if_subscribed: {
            ["x-show"]() {
                return this.$store.userNotificationData.is_subscribed
            },
        },

        show_subscribe_form() {
            this.show_form = true;
        },

        title() {
            return (this.$store.userNotificationData.is_subscribed) ? AlpineI18n.t('notification_edit_title') : AlpineI18n.t('notification_subscribe_title')
        },

        switch_country_code() {
            return (this.selected_country_code == 'kl_GL') ? '+299' : '+45';
        }
    }));
}